module.exports = __webpack_public_path__ + "media/application/images/2023/04_still-1920x1080-4d199a7043b43031b4383f40bba230d5.png";